import { I18n } from "i18n-js";
import Cookies from 'js-cookie';
import ja from "./ja.json";
import en from "./en.json";
import enAu from "./en-AU.json";
import zhCN from "./zh-CN.json";
import zhTW from "./zh-TW.json";
import zhHK from "./zh-HK.json";

const i18n = new I18n({
  ...ja,
  ...en,
  ...enAu,
  ...zhCN,
  ...zhTW,
  ...zhHK,
})

const lang = Cookies.get('lang')
if (lang === 'en-AU') {
  i18n.locale = 'en'
} else if (lang) {
  i18n.locale = lang
} else {
  i18n.locale = 'zh-TW'
}

export const locale_underscore = i18n.locale.replace('-', '_').toLowerCase();

export default i18n
